import { Layers3 } from 'lucide-react';
import GoogleGlyph from '@/src/components/ui/icons/GoogleGlyph';
import { LucideIcon } from '@/src/components/LucideIcon';
import { RedditGlyph } from './RedditGlyph';

export type ReviewSourceId = 'web' | 'google' | 'reddit';

export function ReviewsSourceIcon({ source }: { source: ReviewSourceId }) {
  if (source === 'google') return <GoogleGlyph />;
  if (source === 'reddit') return <RedditGlyph />;
  return <LucideIcon icon={Layers3} size="sm" />;
}
